import type { ApiErrorResponse } from '../../types/frontend';

/**
 * Extract a user-friendly error message from an unknown error.
 * Handles axios errors (response.data.error), standard Error objects, and unknown types.
 */
export function extractErrorMessage(err: unknown, fallback: string = 'An error occurred'): string {
  if (err instanceof Error) return err.message;
  if (err && typeof err === 'object') {
    const axiosError = err as ApiErrorResponse;
    return axiosError.response?.data?.error || axiosError.message || fallback;
  }
  return fallback;
}

/**
 * Extract error message with detail (for test results and diagnostics).
 */
export function extractErrorWithDetail(err: unknown, fallback: string = 'An error occurred'): { message: string; detail: string } {
  if (err instanceof Error) return { message: err.message, detail: '' };
  if (err && typeof err === 'object') {
    const axiosError = err as ApiErrorResponse;
    return {
      message: axiosError.response?.data?.error || axiosError.message || fallback,
      detail: axiosError.response?.data?.detail || '',
    };
  }
  return { message: fallback, detail: '' };
}
